import { Alert } from "components/alert/Alert";

import "./ToastNotification.scss";

export type ToastNotificationVariant = "success" | "warning" | "error";

type ToastNotificationProps = {
  message: string;
  onClose: () => void;
  variant: ToastNotificationVariant;
  className: string;
};

function ToastNotification({
  message,
  onClose,
  variant,
  className
}: ToastNotificationProps) {
  return (
    <Alert
      onDismiss={onClose}
      variant={variant}
      className={`toast-notification ${className}`}
    >
      <span>{message}</span>
    </Alert>
  );
}

export default ToastNotification;
